// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","481":"ba063190","513":"3b400714","706":"711ede07","726":"2b58ec26","857":"b1c699dd"}[chunkId] + ".chunk.js";
};